'use strict';

module.exports = function (page, preventRequest) {

  page = page ? page : this.$refs.page.value;

  if (!this.opts.pagination.dropdown) this.$refs.pagination.Page = page;

  this.page = page;

  this.updateState('page', page);

  if (this.source == 'server' && !preventRequest) this.getData();
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/set-page.js
// module id = 970
// module chunks = 0